<template>
    <div class="footer">

        <!-- <svg class="curve-up" xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="100" viewBox="0 0 100 100" preserveAspectRatio="none">
            <path d="M0 100 C 20 0 50 0 100 100 Z"></path>
        </svg> -->
        <zendesk-widget-button/>
        <div class="main bg-primary py-4">
            <div class="container">
                <div class="row">
                    <div class="col-lg-3 col-md-6 mx-auto mt-md-0 mt-3 text-uppercase">
                        <h6 class="m-0 mb-3 font-weight-bold text-uppercase text-white">Company</h6>
                        <ul class="list-unstyled">
                            <li>
                                <a href="//www.studiesweekly.com/about/" target="_blank">About</a>
                            </li>
                            <li>
                                <a href="//www.studiesweekly.com/contact/" target="_blank">Contact</a>
                            </li>
                            <li>
                                <a href="//www.studiesweekly.com/legal/" target="_blank">Privacy</a>
                            </li>
                            <!-- <li>
                                <a href="//www.studiesweekly.com/careers/" target="_blank">Careers</a>
                            </li> -->
                        </ul>
                    </div>
                    <div class="col-lg-3 col-md-6 mx-auto mt-md-0 mt-3 text-uppercase">
                        <h6 class="m-0 mb-3 font-weight-bold text-uppercase text-white">Product</h6>
                        <ul class="list-unstyled">
                            <li>
                                <router-link :to="{name: 'social-studies', params: {subject: 'social-studies'}}">
                                    Social Studies
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{name: 'science', params: {subject: 'science'}}">
                                    Science
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{name: 'health', params: {subject: 'health'}}">
                                    Health & Wellness
                                </router-link>
                            </li>
                            <!-- <li>
                                <router-link :to="{name: 'civil-rights', params: {state: stateData.state, subject: 'civil-rights'}}">
                                    Civil Rights
                                </router-link>
                            </li> -->
                            <li>
                                <a href="//app.studiesweekly.com/online/free_trial" target="_blank">
                                    Free Online Trial
                                </a>
                            </li>
                            <li>
                                <a href="//www.studiesweekly.com/product/sample/" target="_blank">
                                    Request a Sample
                                </a>
                            </li>
                            <li>
                                <a href="https://www.studiesweekly.com/support/get-a-quote/" target="_blank">Get a Quote</a>
                            </li>
                        </ul>
                    </div>
                    <div class="col-lg-3 col-md-6 mx-auto mt-lg-0 mt-3 text-uppercase">
                        <h6 class="m-0 mb-3 font-weight-bold text-uppercase text-white">Support</h6>
                        <ul class="list-unstyled">
                            <li>
                                <a href="https://support.studiesweekly.com/hc/en-us/requests/new" target="_blank">Contact Tech Support</a>
                            </li>
                            <!-- <li>
                                <a href="https://www.studiesweekly.com/professional-development/" target="_blank">
                                    Professional Development
                                </a>
                            </li> -->
                            <li>
                                <a href="//www.studiesweekly.com/support/find-my-sales-rep/" target="_blank">Find My Sales Rep</a>
                            </li>
<!--                            <li>-->
<!--                                <router-link :to="`/order-form/${stateData.state}`" target="_blank" class="">-->
<!--                                    OrderDetails Form-->
<!--                                </router-link>-->
<!--                            </li>-->
                            <li>
                                <a href="https://www.studiesweekly.com/help-faq/" target="_blank">Help/FAQ</a>
                            </li>
                        </ul>
                    </div>
                    <div class="col-lg-3 col-md-6 mx-auto mt-lg-0 mt-3 text-uppercase">
                        <h6 class="m-0 mb-3 font-weight-bold text-uppercase text-white">Connect</h6>
                        <ul class="list-unstyled">
                            <li>
                                <a href="//www.studiesweekly.com/newsletter/" target="_blank">Newsletter</a>
                            </li>
                            <li>
                                <a href="//www.studiesweekly.com/blog/" target="_blank">Blog</a>
                            </li>
                            <!-- <li>
                                <router-link :to="{name: 'home'}">
                                    Store
                                </router-link>
                            </li> -->
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="py-3 bg-dark">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6 text-white text-lg-left text-center">
                        &copy; {{new Date().getFullYear()}} <a href="//www.studiesweekly.com" class="text-white" target="_blank">Studies Weekly</a> | All Rights Reserved
                    </div>
                    <div class="col-lg-6 mt-lg-0 mt-3 text-lg-right text-md-center text-center social-links">
                        <a href="//www.facebook.com/studiesweekly/" target="_blank">
                            <font-awesome-icon :icon="['fab', 'facebook-f']" />
                        </a>
                        <a href="//www.linkedin.com/company/studies-weekly/" class="ml-3" target="_blank">
                            <font-awesome-icon :icon="['fab', 'linkedin-in']" />
                        </a>
<!--                        <a href="//twitter.com/studiesweekly" class="ml-3" target="_blank">-->
<!--                            <font-awesome-icon :icon="['fab', 'twitter']" />-->
<!--                        </a>-->
                        <a href="//www.threads.net/@studiesweekly" class="ml-3" target="_blank">
                            <font-awesome-icon :icon="['fab', 'threads']" />
                        </a>
                        <a href="//www.pinterest.com/studiesw/" class="ml-3" target="_blank">
                            <font-awesome-icon :icon="['fab', 'pinterest']" />
                        </a>
                        <a href="//www.instagram.com/studiesweekly/" class="ml-3" target="_blank">
                            <font-awesome-icon :icon="['fab', 'instagram']" />
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="py-3 bg-dark">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6 text-white text-lg-left text-center">
                        &nbsp;
                    </div>
                    <div class="col-lg-6 mt-lg-0 mt-3 text-lg-right text-md-center text-center social-links">
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "@/assets/scss/_colors.scss";

.footer li + li {
    // margin-top: 5px;
}

.footer .main a {
    color: $white;
}

.footer .social-links a {
    color: darken($white, 10%);
}

.footer .social-links a:focus,
.footer .social-links a:hover {
    color: $white;
}

.footer .curve-up {
    background-color: $light;
}

.bg-white + .footer .curve-up {
    background-color: $white;
}

.bg-light + .footer .curve-up {
    background-color: $light;
}

.footer .curve-up path {
    fill: $primary;
    stroke: $primary;
}

@media (max-width: 991px) {
    .curve-up {
        display: none;
    }
}
</style>

<script>
import { mapState } from 'vuex'

import states from '@/common/states'
import ZendeskWidgetButton from "@/components/ZendeskWidgetButton.vue";

export default {
    components: {ZendeskWidgetButton},
    data: () => ({
        states: states
    }),
    computed: mapState({
        stateData: state => state.stateData.stateData,
        selectedState: state => state.stateData.selectedState
    }),
    props: {},
    methods: {
        fullState (selectedState) {
            var fullState = null
            _.forEach(this.states, state => {
                if (selectedState == state.state) {
                    fullState = state.fullState
                }
            })
            return fullState
        }
    }
}
</script>
